export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14339.6f168c59.jpg";